/* eslint-disable @typescript-eslint/no-floating-promises */
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import ChallanKeyFeatures from '@components/ChallanKeyFeaturs'
import { getClassNames } from '@helpers/productWidgetHelper'
import { ABHA_WIDGET, TAP_BTN_EVENT, FUNNEL_TYPE } from '@components/Product/ProductWidget/constants'
import { isHsrpLandingWidget, isVasWidget } from '@helpers/vasLandingPageHelper'
import HsrpSaftySystems from '@components/HsrpSaftySystems'
import ProductHealthInfoCards from './ProductHealthInfoCard/ProductHealthInfoCard'
import KeyFeatures from '../keyFeatures'
import { ProductKeyFeaturesAndCtaProps } from './productInterfaces'
import styles from '../productWidget.module.scss'

const ProductKeyFeaturesAndCta: React.FC<ProductKeyFeaturesAndCtaProps> = ({
  content,
  isMobileView,
  isAutoWidgetLayout,
  isSeoCarWidget,
  THEME_CONFIG,
  segmentEventCommonProperties,
  renderCtaButton,
  isHealthWidgetPurpleLayout = false,
  hideSection = false,
  getCtaWidgetPurpleLayout = false,
  onCtaClick,
}) => {
  const handleButtonClick = () => {
    ;(async () => {
      await trackEvent(TAP_BTN_EVENT, {
        ...segmentEventCommonProperties,
        funnel: FUNNEL_TYPE.ENGAGE,
        source: content?.cta?.name,
      })
      if (onCtaClick) {
        onCtaClick()
      } else {
        window.location.href = content?.cta?.link
      }
    })()
  }

  const isVasLandingPage = isVasWidget(content?.widget)
  const isHsrpLandingPage = isHsrpLandingWidget(content?.widget)
  const desktopMwebContainerClassNames = getClassNames([], {
    [styles.semLayoutKeyFeaturesMobile]: isMobileView,
    [styles.semLayoutKeyFeaturesDesktopContainer]: !isMobileView && isAutoWidgetLayout,
    [styles.seoDontRenderContent]: isHealthWidgetPurpleLayout || getCtaWidgetPurpleLayout,
  })
  const marginRequired = isMobileView || isAutoWidgetLayout

  return (
    <>
      {!isSeoCarWidget && !isVasLandingPage && !!content?.KeyFeatures?.length && (
        <div className={desktopMwebContainerClassNames}>
          <KeyFeatures
            keyFeaturesData={content.KeyFeatures}
            isMarginRequired={marginRequired}
            themeClassname={THEME_CONFIG[content?.theme]}
          />
        </div>
      )}

      {isHealthWidgetPurpleLayout && !hideSection && (
        <ProductHealthInfoCards isMobile isHealthWidgetLayout widget={ABHA_WIDGET} />
      )}

      {isVasLandingPage && !isHsrpLandingPage && <ChallanKeyFeatures content={content} isMobileView={isMobileView} />}

      {isHsrpLandingPage && <HsrpSaftySystems content={content} isMobileView={isMobileView} />}

      {renderCtaButton && content?.cta?.name && (
        <div className={styles.ctaButton} onClick={handleButtonClick}>
          {content?.cta?.name}
        </div>
      )}
    </>
  )
}

export default ProductKeyFeaturesAndCta
